export default "__VITE_ASSET__uFduHC1A__"